import { render, staticRenderFns } from "./accession-company-modal.vue?vue&type=template&id=2e2e7712"
import script from "./accession-company-modal.vue?vue&type=script&lang=js"
export * from "./accession-company-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports